import React from "react";
import { classList } from "@utils";
import { Form } from "react-bootstrap";
// import Select from "react-select";

function RenderSelectInput(props) {
  const { name, error, display, touched, items, required, type, ...rest } =
    props;

  return (
    <>
      <div
        className={classList({
          "col-md mb-3": true,
          "valid-field": !error && touched,
          "invalid-field": error && touched,
        })}
      >
        <label htmlFor={name}>
          {display} {required ? <span className="text-danger">*</span> : ""}
        </label>

        <select className="form-select" id={name} name={name} {...rest}>
          {type !== "number" ? (
            <option value="">-- Select {display} --</option>
          ) : (
            <option value={0}>-- Select {display} --</option>
          )}

          {items ? (
            items.map((item, index) => {
              return (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              );
            })
          ) : (
            <>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </>
          )}
        </select>

        {/* <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback> */}

        <div
          type="invalid"
          style={{
            fontSize: "10px",
            color: "red",
          }}
        >
          {error}
        </div>
      </div>
    </>
  );
}

function RenderTextInput(props) {
  const { name, error, display, touched, required, hidden, ...rest } = props;
  return hidden ? (
    ""
  ) : (
    <>
      <div
        className={classList({
          "col-md mb-3": true,
          "valid-field": !error && touched,
          "invalid-field": error && touched,
        })}
      >
        <label htmlFor={name}>
          {display} {required ? <span className="text-danger">*</span> : ""}
        </label>
        <input className="form-control" id={name} name={name} {...rest} />
        {/* <div className="valid-feedback">Looks good!</div> */}
        {/* <div className="invalid-feedback">{error}</div> */}
        <div
          type="invalid"
          style={{
            fontSize: "10px",
            color: "red",
          }}
        >
          {error}
        </div>
      </div>
    </>
  );
}

function RenderTextArea(props) {
  const { name, error, display, touched, required, hidden, ...rest } = props;
  return hidden ? (
    ""
  ) : (
    <>
      <div
        className={classList({
          "col-md mb-3": true,
          "valid-field": !error && touched,
          "invalid-field": error && touched,
        })}
      >
        <label htmlFor={name}>
          {display} {required ? <span className="text-danger">*</span> : ""}
        </label>
        {/* <input className="form-control" id={name} name={name} {...rest} /> */}
        {/* <div className="valid-feedback">Looks good!</div> */}
        <textarea
          rows="2"
          className="form-control"
          id={name}
          name={name}
          style={{ resize: "none" }}
          {...rest}
        />
        {/* <div className="invalid-feedback">{error}</div> */}
        <div
          type="invalid"
          style={{
            fontSize: "10px",
            color: "red",
          }}
        >
          {error}
        </div>
      </div>
    </>
  );
}

function RenderCheckboxInput(props) {
  const { name, error, display, touched, required, value, ...rest } = props;
  return (
    <>
      <div
        className={classList({
          "col-md mb-3": true,
          "valid-field": !error && touched,
          "invalid-field": error && touched,
        })}
      >
        {/* <label htmlFor={name}>
          {display} {required ? <span className="text-danger">*</span> : ""}
        </label> */}
        <br />
        <Form.Check
          id={name}
          name={name}
          {...rest}
          type="switch"
          inline
          label={display}
          checked={value}
        />
        {/* <div className="invalid-feedback">{error}</div> */}
        <div
          type="invalid"
          style={{
            fontSize: "10px",
            color: "red",
          }}
        >
          {error}
        </div>
      </div>
    </>
  );
}

function RenderDateInput(props) {
  const { name, error, display, touched, required, hidden, ...rest } = props;
  return hidden ? (
    ""
  ) : (
    <>
      <div
        className={classList({
          "col-md mb-3": true,
          "valid-field": !error && touched,
          "invalid-field": error && touched,
        })}
      >
        <label htmlFor={name}>
          {display} {required ? <span className="text-danger">*</span> : ""}
        </label>
        <input className="form-control" id={name} name={name} {...rest} />
        {/* <div className="valid-feedback">Looks good!</div> */}
        {/* <div className="invalid-feedback">{error}</div> */}
        <div
          type="invalid"
          style={{
            fontSize: "10px",
            color: "red",
          }}
        >
          {error}
        </div>
      </div>
    </>
  );
}

export {
  RenderSelectInput,
  RenderTextInput,
  RenderCheckboxInput,
  RenderDateInput,
  RenderTextArea,
};
